import ModalOrBottomSheetWrapper from "@vahak/core-ui/dist/components/ModalOrBottomSheetWrapper";
import TextCTA from "@vahak/core-ui/dist/components/TextCTA";
import { useToggleModalWithLocalState } from "@vahak/core-ui/dist/hooks";
import React, { ComponentProps } from "react";
import StopPropagation from "../../../helper/StopPropagation";
import LoadStopsList from "./LoadStopsList";
import Button from "@vahak/core-ui/dist/components/Button";
import useValidateUserStatus from "../../../../hooks/useValidateUserStatus";
import Typography from "@vahak/core-ui/dist/components/Typography";

interface LoadStopsPopupProps extends ComponentProps<typeof LoadStopsList> {
    actionText?: string;
}

const LoadStopsPopup = ({ actionText = "Multi-stop", ...restProps }: LoadStopsPopupProps) => {
    const popupState = useToggleModalWithLocalState();
    const { loginCheck } = useValidateUserStatus();

    const wrappedCtaAction = () => {
        loginCheck() && popupState?.openModal();
    };

    return (
        <StopPropagation>
            <TextCTA onClick={wrappedCtaAction} underline weight="medium">
                <Typography noWrap>{actionText}</Typography>
            </TextCTA>
            <ModalOrBottomSheetWrapper
                isOpen={popupState?.isModalOpen}
                onToggle={popupState?.toggleModal}
                titleText="Stop locations"
                renderFooter={
                    <div data-popup-footer>
                        <Button blockBtn onClick={() => popupState.closeModal()}>
                            Okay
                        </Button>
                    </div>
                }
            >
                <LoadStopsList {...restProps} />
            </ModalOrBottomSheetWrapper>
        </StopPropagation>
    );
};

export default LoadStopsPopup;
